import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import BigOnOffCards from '../components/BigOnOffCards';
import MessagePreview from '../components/MessagePreview';

const VARIABLES = ['{{first_name}}', '{{practice_name}}', '{{treatment_name}}'];

export default function TreatmentStep({ formData, onChange, practiceName, practiceLogo }) {
    const sampleValues = {
        first_name: 'Sarah',
        practice_name: practiceName || 'Your Practice',
        treatment_name: 'Invisalign',
    };

    return (
        <Box>
            <Typography sx={{
                fontSize: 11, fontWeight: 700, letterSpacing: '0.08em',
                textTransform: 'uppercase', color: '#00A76F', mb: '10px',
            }}>
                Treatment enquiries
            </Typography>
            <Typography sx={{
                fontSize: 22, fontWeight: 800, color: '#0D0D0D',
                lineHeight: 1.3, letterSpacing: '-0.4px', mb: 1,
            }}>
                Acknowledge treatment enquiries?
            </Typography>
            <Typography sx={{ fontSize: 13.5, color: '#7A7A7A', lineHeight: 1.6, mb: '20px' }}>
                AI automatically detects treatments mentioned by patients and assigns them to the lead — this is always active.
            </Typography>

            {/* Always-on info banner */}
            <Box sx={{
                display: 'flex', alignItems: 'center', gap: '10px',
                p: '12px 14px', mb: '20px',
                borderRadius: '12px',
                backgroundColor: 'rgba(0, 167, 111, 0.06)',
                border: '1px solid rgba(0, 167, 111, 0.15)',
            }}>
                <Icon icon="mdi:check-circle" width={20} height={20} style={{ color: '#00A76F', flexShrink: 0 }} />
                <Typography sx={{ fontSize: 12.5, color: '#212B36', lineHeight: 1.5 }}>
                    <strong>Treatment detection is always on.</strong>{' '}When a patient mentions a treatment like &ldquo;Invisalign&rdquo;, it&rsquo;s automatically assigned to their lead.
                </Typography>
            </Box>

            <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#3D3D3D', mb: '12px' }}>
                Also send a reply to the patient?
            </Typography>

            <BigOnOffCards
                checked={formData.auto_send_treatment_template ?? false}
                onChange={(val) => onChange('auto_send_treatment_template', val)}
                yesTitle="Yes, acknowledge"
                yesDesc="Assigns treatment and sends a quick reply"
                noTitle="No, just assign"
                noDesc="Assigns treatment silently, no message sent"
            />

            {formData.auto_send_treatment_template && (
                <MessagePreview
                    message={formData.treatment_message}
                    onChange={(val) => onChange('treatment_message', val)}
                    variables={VARIABLES}
                    sampleValues={sampleValues}
                    practiceName={practiceName}
                    practiceLogo={practiceLogo}
                />
            )}

        </Box>
    );
}

TreatmentStep.propTypes = {
    formData: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};
